import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { isPreSale } from 'common/helpers/featureFlags';
import { hasClubs, hasReservations } from 'profile/common/helpers';

const SubMenu = () => {
  const clubReducer = useSelector((state) => state.club);
  const reservationTypeReducer = useSelector((state) => state.reservationType);
  const settings = useSelector((state) => state.setting.data);

  return (
    <div className="c7-account-menu">
      <Link to="/profile">Dashboard</Link>
      <Link to="/profile/account">Your Information</Link>
      <Link to="/profile/order-history">Order History</Link>
      <ClubLink clubs={clubReducer} />
      <ReservationLink reservationTypes={reservationTypeReducer} />
      <LoyaltyPointsLink loyalty={settings?.loyalty} />
      <Link to="/profile/address-book">Address Book</Link>
      <Link to="/profile/credit-card">Credit Cards</Link>
      <a href="/profile/logout">Logout</a>
    </div>
  );
};

const LoyaltyPointsLink = (props) => {
  const { loyalty } = props;
  if (!loyalty?.hasLoyalty || loyalty.status === 'Planning') {
    return null;
  }

  return <Link to="/profile/loyalty-point">Loyalty Points</Link>;
};

const ClubLink = (props) => {
  const { clubs } = props;
  if (!hasClubs(clubs)) {
    return null;
  }
  let menuItem = 'Club Memberships';
  if (isPreSale()) {
    menuItem = 'Pre-Sale Signup';
  }

  return <Link to="/profile/club-membership">{menuItem}</Link>;
};

const ReservationLink = (props) => {
  const { reservationTypes } = props;
  if (!hasReservations(reservationTypes)) {
    return null;
  }

  return <Link to="/profile/reservation">Reservations</Link>;
};

export default SubMenu;
